
export default class ImageHelper {
  constructor() {
    this.resizer = window.pica();
  }

  async resizeBase64Image({
    base64Image,
    maxWidth = 1200,
    maxHeight = 1200,
    compressionAmount = 0.8,
    skipContrastEnhancement = false,
  }) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = async () => {
        if (img.width < maxWidth && img.height < maxHeight) {
          return resolve(base64Image);
        }

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;

        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        let newWidth = 0;
        let newHeight = 0;
        let maxSize = Math.max(maxWidth, maxHeight);
        let resizeFactor = null;
        if (img.width > maxSize || img.height > maxSize) {
          if (img.width > img.height) {
            newWidth = maxSize;
            resizeFactor = img.height / img.width;
            newHeight = parseInt(maxSize * resizeFactor);
          } else {
            newHeight = maxSize;
            resizeFactor = img.width / img.height;
            newWidth = parseInt(maxSize * resizeFactor);
          }
        } else {
          newWidth = img.width;
          newHeight = img.height;
        }

        const resizingCanvas = document.createElement('canvas');
        const resizingCanvasCtx = resizingCanvas.getContext('2d');
        resizingCanvas.width = newWidth;
        resizingCanvas.height = newHeight;
        resizingCanvasCtx.fillStyle = 'white';
        resizingCanvasCtx.fillRect(0, 0, newWidth, newHeight);

        let picaResizeOptions = {
          alpha: true,
        };

        if (!skipContrastEnhancement) {
          if (img.width - newWidth > 1000 || img.height - newHeight > 1000) {
            picaResizeOptions = {
              unsharpAmount: 80,
              unsharpRadius: 0.6,
              unsharpThreshold: 2,
              alpha: true,
            };
          }
        }

        const result = await this.resizer.resize(canvas, resizingCanvas, picaResizeOptions);
        const blob = await this.resizer.toBlob(result, 'image/jpeg', compressionAmount);
        const base64 = await readFileAsDataUrl(blob);
        resolve(base64);
      };
      img.onerror = reject;
      img.src = base64Image;
    });
  }
}

const readFileAsDataUrl = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
